module.exports = __webpack_public_path__ + "img/balogh_tunde.e0db65dc.jpg";